import {
  ACTION_TABS_PATH,
  ACTION_TABS_PATH_RESET,
  ACTION_TABS_UNLOCK_ALL,
} from '../../actions/ui/actionTabs';

export const initialActionTabsState = {
  path: ['operators-and-vehicles'],
};

// Todas las tabs disponibles para desbloquear en flujo de validación
export const allActionTabs = [
  'operators-and-vehicles',
  'location',
  'edition',
  'budget-items',
  'materials',
  'machinery',
  'animals',
];

type actionTabsType = {
  type: string;
  payload: { path: string };
};

export default function actionTabsReducer(
  state = initialActionTabsState,
  { type, payload }: actionTabsType
) {
  switch (type) {
    case ACTION_TABS_PATH:
      return {
        ...state,
        path: [...state.path, payload.path],
      };
    case ACTION_TABS_PATH_RESET:
      return {
        ...initialActionTabsState,
      };
    case ACTION_TABS_UNLOCK_ALL:
      return {
        ...state,
        path: [...allActionTabs],
      };
    default:
      return state;
  }
}
